import React from "react";
import OrderDetails from "./OrderDetails";

function OrderPage({ order, setPage }) {
  if (!order) {
    return (
      <div className="page">
        <div className="panel">
          <div className="ph">
            <span className="ph-title">Order not found</span>
          </div>
          <div className="pb">
            <div className="empty">
              No order selected. Go back to the orders list.
            </div>
            <div style={{ marginTop: 12 }}>
              <button className="btn btn-p" onClick={() => setPage("orders")}>
                Back to Orders
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="panel">
        <div className="ph">
          <div
            style={{
              display: "flex",
              gap: 12,
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ flex: 1 }}>
              <span className="ph-title">Order Details</span>
              <div className="ph-sub">Full breakdown of the order</div>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <button className="btn btn-g" onClick={() => setPage("orders")}>
                <i className="bi bi-arrow-left" /> Back
              </button>
            </div>
          </div>
        </div>
        <div className="pb">
          <OrderDetails order={order} />
        </div>
      </div>
    </div>
  );
}

export default OrderPage;
